export default "__VITE_ASSET__835466d2__"